import React, { useRef, useEffect } from 'react';

const overlayStyle = {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(0,0,0,0.5)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 9999
};

const contentStyle = {
    backgroundColor: 'white',
    padding: '0', 
    borderRadius: '8px',
    width: '90%',
    maxWidth: '800px',
    boxShadow: '0 5px 15px rgba(0,0,0,.5)',
    position: 'relative',
    overflow: 'hidden',
    aspectRatio: '16/9',
    display: 'flex',
    flexDirection: 'column'
};

const closeButtonStyle = {
    position: 'absolute',
    top: '10px',
    right: '10px',
    background: 'rgba(0,0,0,0.5)',
    border: 'none',
    color: 'white',
    fontSize: '20px',
    cursor: 'pointer',
    borderRadius: '50%',
    width: '30px',
    height: '30px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 10
};

const ModalTutorial = ({ isVisible, onClose, videoId }) => {
    const modalRef = useRef(null);

    // Close on click outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (modalRef.current && !modalRef.current.contains(event.target)) {
                onClose();
            }
        };

        if (isVisible) {
            document.addEventListener("mousedown", handleClickOutside);
        }

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [isVisible, onClose]);

    if (!isVisible) return null;

    return (
        <div style={overlayStyle}>
            <div style={contentStyle} ref={modalRef}>
                <button style={closeButtonStyle} onClick={onClose}>
                    &times;
                </button>
                <iframe
                    width="100%"
                    height="100%"
                    src={`https://www.youtube.com/embed/${videoId}?autoplay=1`}
                    title="Tutorial Video"
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowFullScreen
                ></iframe>
            </div>
        </div>
    );
};

export default ModalTutorial;
